import React, { createContext, useContext, useState, useCallback } from 'react';
import { authenticationService } from 'src/services';
import { get } from 'src/services/httpClient.service';

const WalletContext = createContext<any>(null);

export const WalletProvider = ({ children }) => {
  const [walletAmount, setWalletAmount] = useState<number>(0);

  const API_URL = process.env.REACT_APP_BASE_API_URL;
  //const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();
  const {vendorId, franchiseId, companyId, operatorId} = authenticationService.getVendorFranchiseIds();

  // const fetchFranchisees = useCallback(async () => {
  //   try {
  //     const response = await get(
  //       `${API_URL}/api/franchisees/vendor/${vendorId}/getFranchiseeById?id=${franchiseId}`
  //     );
  //     const amount = response?.data?.walletAmount || 0;
  //     setWalletAmount(amount);
  //   } catch (error) {
  //     console.error('Wallet fetch error', error);
  //   }
  // }, [API_URL, vendorId, franchiseId]);

  const fetchOperatorDetails = useCallback(async () => {
    try {
      const response = await get(`${API_URL}/api/operators/vendor/${vendorId}/getByOperatorId`, { params: { id: operatorId }});
      const amount = response?.data?.walletAmount || 0;
      setWalletAmount(amount);
    } catch (error) {
      console.error('Wallet fetch error', error);
    }
  }, [API_URL, vendorId, operatorId]);

  return (
    <WalletContext.Provider
      value={{
        walletAmount,
        fetchOperatorDetails
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};

export const useWalletContext = () => useContext(WalletContext);
